// Single source of truth for QNNEAL pricing
// Used by LandingPage, Billing, and any other pricing display
// Pricing last updated: Prompt #22.1 — Starter: $29/mo (confirmed)
export const PRICING_PLANS = {
  free: {
    name: "Free",
    price: "$0",
    period: "forever",
    monthlyPrice: 0,
    optimizations_limit: 3,
    description: "Try QNNEAL with basic classical optimization.",
    features: [
      "3 optimizations / month",
      "Sequential DAG only",
      "Classical solver only",
      "1 agent team",
      "Community support",
    ],
    cta: "Get Started Free",
    featured: false,
  },
  starter: {
    name: "Starter",
    price: "$29",
    period: "/month",
    monthlyPrice: 29,
    optimizations_limit: 50,
    description: "For individual developers and small projects.",
    features: [
      "50 optimizations / month",
      "Parallel DAG optimization",
      "Classical solver + MCP API access",
      "1 agent team",
      "Community support",
    ],
    cta: "Subscribe",
    featured: false,
  },
  team: {
    name: "Team",
    price: "$199",
    period: "/month",
    monthlyPrice: 199,
    optimizations_limit: 10000,
    description: "For teams running production agent workflows.",
    features: [
      "10,000 optimizations / month",
      "Parallel DAG + Deep Optimization",
      "Quantum computing access (connect your own QPU provider)",
      "Unlimited agent teams",
      "Analytics dashboard",
      "Priority support",
      "SSO & RBAC",
    ],
    cta: "Start Free Trial",
    featured: true,
  },
  enterprise: {
    name: "Enterprise",
    price: "Custom",
    period: "",
    monthlyPrice: null,
    optimizations_limit: "Unlimited",
    description: "For organizations at scale with dedicated infrastructure.",
    features: [
      "Unlimited optimizations",
      "Parallel DAG + Quantum-Enhanced",
      "Dedicated quantum computing resources (QPU)",
      "Custom SLA (99.99%)",
      "On-premise deployment",
      "Dedicated account manager",
      "24/7 phone support",
    ],
    cta: "Contact Sales",
    featured: false,
  },
};

export const PRICING_LIST = Object.values(PRICING_PLANS);

export const SAVINGS_RANGE = { min: 30, max: 55 };
